import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/data';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              最新内容
            </h2>
            <p className="text-foreground-600 text-sm">持续更新的精品内容库</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => {
            const cat = categories.find((c) => c.slug === article.category);
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden transition-all duration-300 hover:scale-[1.02]"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    title={`${article.title} - 亚洲精品一区二区`}
                  />
                  <div className="absolute top-3 left-3">
                    <span
                      className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                        article.category === 'zone1'
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-accent-500 text-background-50'
                      }`}
                    >
                      {cat?.name}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <div className="flex flex-wrap gap-1.5 mb-3">
                    {article.tags.slice(0, 2).map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-foreground-600 text-xs leading-relaxed mb-4 line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span>{article.author}</span>
                    <span>{article.publishDate}</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}